import { z } from "zod";

// ─── Enums ───────────────────────────────────────────────────────────────────

export const ApiDayOfWeekSchema = z.enum([
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
]);
export type ApiDayOfWeek = z.infer<typeof ApiDayOfWeekSchema>;

// ─── Core Entity ─────────────────────────────────────────────────────────────

export const ManagerAvailabilitySchema = z.object({
  managerId: z.uuid(),
  companyId: z.uuid(),
  availability: z.record(ApiDayOfWeekSchema, z.array(z.string())),
  updatedAt: z.string(),
});
export type ManagerAvailability = z.infer<typeof ManagerAvailabilitySchema>;

// ─── Response Schemas ─────────────────────────────────────────────────────────

export const ManagerAvailabilityResponseSchema = z.union([
  ManagerAvailabilitySchema,
  z.object({ availability: z.null() }),
]);
export type ManagerAvailabilityResponse = z.infer<
  typeof ManagerAvailabilityResponseSchema
>;

// ─── Request Schemas ──────────────────────────────────────────────────────────

export const SaveManagerAvailabilityRequestSchema = z.object({
  availability: z.record(ApiDayOfWeekSchema, z.array(z.string())),
});
export type SaveManagerAvailabilityRequest = z.infer<
  typeof SaveManagerAvailabilityRequestSchema
>;
